class StickyBuyButton extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    const addToCart = this.closest('product-info')?.querySelector('.buy-buttons-block');
    if (!addToCart) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const regularBuyButtonsAreHidden = window.getComputedStyle(addToCart).display === 'none';
        const regularBuyButtonsWerePassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

        this.setAttribute('aria-hidden', String(!regularBuyButtonsAreHidden && !regularBuyButtonsWerePassed));
      }, { threshold: 0 }
    );
    this.observer.observe(addToCart);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-buy-button', StickyBuyButton);
